var blocks = document.querySelectorAll(".listing-slider, .gallery-slider");
blocks.forEach(function (block) {
	// It would be nice if these were abstracted a bit
	const carousel = block.querySelector(".items, .wp-block-gallery");
	if (!carousel) {
		return false;
	}
	const slides = carousel.querySelectorAll(".items > *, .wp-block-gallery > *");

	const controls = block.querySelector(".slider-controls");
	const nextButton = block.querySelector(".slider-controls button[data-direction='next']");
	const prevButton = block.querySelector(".slider-controls button[data-direction='previous']");

	const observerSettings = {
		root: carousel,
		rootMargin: "-20px",
		threshold: 0.2,
	};

	// We need intersection observer for this to work
	if ("IntersectionObserver" in window) {
	} else {
		return false;
	}

	// We don't need to do anything if there's only one slide
	if (slides.length <= 1) {
		return false;
	}

	// Figure out if slides are full width
	let slidesAreFullWidth = false;
	if (carousel.clientWidth === slides[0].clientWidth) {
		slidesAreFullWidth = true;
	}

	// Set basics for the carousel
	carousel.classList.add("is-slider");
	slides.forEach(function (slide, index) {
		// Set data attribute for slide number
		slide.setAttribute("data-slide", index);
	});

	var goToSlide = function goToSlide(index) {
		let targetSlide = carousel.querySelector("[data-slide='" + index + "']");

		if (targetSlide) {
			carousel.scrollTo({
				left: targetSlide.offsetLeft,
				behavior: "smooth",
			});
		} else {
			console.error("Could not show slide: " + index);
		}
	};

	var getCurrentSlide = function getCurrentSlide() {
		var currentSlide = carousel.querySelector(".is-visible");
		var currentSlideIndex = parseInt(currentSlide.dataset.slide);

		return currentSlideIndex;
	};

	var updateSlides = function updateSlides(changed_slides) {
		// Deal with intersection observer entries that changed
		Array.prototype.forEach.call(changed_slides, function (entry) {
			var slide = entry.target;

			// All slides:
			// - Remove visible class
			// - Set all links to be non-interactive
			slide.classList.remove("is-visible");
			var slide_links = slide.querySelectorAll("a");
			slide_links.forEach(function (link) {
				link.setAttribute("tabindex", "-1");
			});

			// Bail if the slide is not visible
			if (!entry.isIntersecting) {
				return;
			}

			// We now know this is a visible slide
			slide.classList.add("is-visible");

			// Set all links to be interactive
			slide_links.forEach(function (link) {
				link.removeAttribute("tabindex", "-1");
			});

			// Set active pager dot
			if (slidesAreFullWidth) {
				var index = slide.getAttribute("data-slide");
				var pager_dots = controls.querySelectorAll(".dot");
				pager_dots.forEach(function (dot) {
					if (dot.dataset.slide === index) {
						dot.classList.add("is-active");
					} else {
						dot.classList.remove("is-active");
					}
				});
			}
		});

		// Update disabled/enabled state for arrows
		prevButton.removeAttribute("disabled");
		nextButton.removeAttribute("disabled");

		if (slides[0].matches(".is-visible")) {
			prevButton.setAttribute("disabled", "disabled");
		}
		if (slides[slides.length - 1].matches(".is-visible")) {
			nextButton.setAttribute("disabled", "disabled");
		}
	};

	// Set up next/previous controls
	controls.setAttribute("aria-label", "Slider Controls");
	controls.removeAttribute("hidden");

	nextButton.addEventListener("click", function (event) {
		var currentSlide = getCurrentSlide();

		if (currentSlide < slides.length - 1) {
			goToSlide(currentSlide + 1);
		} else {
			goToSlide(0);
		}
	});
	prevButton.addEventListener("click", function (event) {
		var currentSlide = getCurrentSlide();

		if (currentSlide > 0) {
			goToSlide(currentSlide - 1);
		} else {
			goToSlide(0);
		}
	});

	// Add pager dots if slides are full width
	if (slidesAreFullWidth) {
		controls.classList.add("has-pager");
		slides.forEach(function (slide, index) {
			var listItem = document.createElement("li");

			// console.log(index);
			var pagerButton = document.createElement("button");
			pagerButton.classList.add("dot");
			pagerButton.setAttribute("data-slide", index);

			var pagerButtonLabel = document.createElement("span");
			pagerButtonLabel.classList.add("visually-hidden");
			pagerButtonLabel.textContent = "Slide " + (index + 1);

			pagerButton.append(pagerButtonLabel);

			// add click event to go to slide
			pagerButton.addEventListener("click", (event) => {
				var currentSlide = getCurrentSlide();
				// console.log("clicked pager item: " + index);
				// console.log("active slide: " + currentSlide);

				if (index !== currentSlide) {
					pagerButton.classList.add("active");
					goToSlide(index);
				}
			});

			listItem.appendChild(pagerButton);

			controls.insertBefore(listItem, nextButton.parentElement);
		});
	}

	// Add observer of slide changing
	var observer = new IntersectionObserver(updateSlides, observerSettings);
	Array.prototype.forEach.call(slides, function (t) {
		return observer.observe(t);
	});
});
